import React from 'react'
import { GumletPlayer } from '@gumlet/react-embed-player'

const WORKSPACE_ID = '6799a0f3f899e3667687c2d3'

export const VideoPlayer = ({videoID}) => {
    return (
        <div className='print-hide pb-3'>
                <GumletPlayer videoID={videoID} />
        </div>
    )
}

export const VideoThumbnail = ({videoID, width=320, height=180}) => {
    return (
        <div className='screen-hide pb-3'>
            <img
                className='img-fluid'
                src={`https://video.gumlet.io/${WORKSPACE_ID}/${videoID}/thumbnail-1-0.png`}
                alt="Video Thumbnail"
            />
        </div>
    )
}
